import { useEffect, useState } from 'react';

// Elapsed-seconds stopwatch for the IDE. Resets to 0 whenever `resetKey`
// changes (i.e. when the user navigates to a different problem) and ticks
// once per second while mounted.
export function useIdeTimer(resetKey: string | undefined): number {
  const [elapsedSecs, setElapsedSecs] = useState(0);
  useEffect(() => {
    setElapsedSecs(0);
    const id = setInterval(() => setElapsedSecs(s => s + 1), 1000);
    return () => clearInterval(id);
  }, [resetKey]);
  return elapsedSecs;
}
